import {mapActions, mapGetters, mapMutations} from 'vuex';

export default {
	name		: 'courses-main',
	data() {
		return {}
	},
	async created() {
		const slug = this.$route.params.item;
		
		if (!this.currentItem || this.currentItem.slug !== slug) {
			this.setContent(null);
			try {
				await this.fetchData({ slug });
			} catch (err) {
				const status = err && err.response && err.response.status;
				if (status === 403) {
					this.$router.replace(this.$localize({ name: "courses" }));
				}
			}
		}
	},
	watch: {},
	components	: {},
	mounted() {},
	computed	: {
		...mapGetters({
			currentItem	: 'courses/currentItem',
			isLoading	: 'courses/isLoading',
		})
	},
	methods		: {
		...mapActions({
			fetchData	: 'courses/GET_COURSE_ITEM',
		}),
		...mapMutations({
			setContent	: `courses/SET_ITEM`
		}),
	}
}
